import React from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "../../util/asyncComponent";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min.js";

const Admin = ({ match }) => {
  const { user } = useSelector(({ auth }) => auth);
  const hasAccountReadPermission = user?.account?.read;

  const ProtectedRoute = ({ component: Component, permission, ...rest }) => {
    const { user } = useSelector((state) => state.auth);

    const hasPermission =
      permission === undefined ||
      user?.tabPermission?.some(
        (item) =>
          item.tabId?.tabUrl === permission &&
          item.tabId?.isActive &&
          item.view,
      );

    return (
      <Route
        {...rest}
        render={(props) =>
          hasPermission ? <Component {...props} /> : <Redirect to="/erropage" />
        }
      />
    );
  };

  return (
    <div className="gx-main-content-wrapper">
      <Switch>
        <ProtectedRoute
          exact
          permission="dashboard"
          path={`${match.url}dashboard`}
          component={
            user?.userType === "operator"
              ? asyncComponent(() => import("./OperatorDashboard/index.js"))
              : asyncComponent(() => import("./Dashboard/index.js"))
          }
        />
        <ProtectedRoute
          exact
          permission="bank/account"
          path={`${match.url}bank/account`}
          component={asyncComponent(() => import("./bank/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="bank/account"
          path={`${match.url}bank/editbank`}
          component={asyncComponent(() => import("./AddBankList/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="bank/account"
          path={`${match.url}bank/addbank`}
          component={asyncComponent(() => import("./AddBankList/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="deposit/report"
          path={`${match.url}deposit/report`}
          component={asyncComponent(() => import("./DepositReport/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="withdraw/report"
          path={`${match.url}withdraw/report`}
          component={asyncComponent(() => import("./WithdrawReport/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="deposit/queue"
          path={`${match.url}deposit/queue`}
          component={asyncComponent(() => import("./Deposit/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="deposit-auto-queue"
          path={`${match.url}deposit-auto-queue`}
          component={asyncComponent(() => import("./Deposit/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="withdraw/queue"
          path={`${match.url}withdraw/queue`}
          component={asyncComponent(() => import("./Withdraw/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="withdraw-pending-report"
          path={`${match.url}withdraw-pending-report`}
          component={asyncComponent(() => import("./Withdraw/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="changepassword"
          path={`${match.url}changepassword`}
          component={asyncComponent(() => import("./ChangePassword/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="operator"
          path={`${match.url}operator`}
          component={asyncComponent(() => import("./Operator/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="operator"
          path={`${match.url}operator/addoperator`}
          component={asyncComponent(
            () => import("./Operator/AddOperator/index.js"),
          )}
        />
        <ProtectedRoute
          exact
          permission="operator"
          path={`${match.url}operator/editoperator`}
          component={asyncComponent(
            () => import("./Operator/AddOperator/index.js"),
          )}
        />
        <ProtectedRoute
          exact
          permission="setting"
          path={`${match.url}setting`}
          component={asyncComponent(() => import("./Setting/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="setting"
          path={`${match.url}entity-report`}
          component={asyncComponent(() => import("./websiteReport/index.js"))}
        />

        <ProtectedRoute
          exact
          permission="deposit-rollback"
          path={`${match.url}deposit-rollback`}
          component={asyncComponent(() => import("./DepositReport/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="transaction-list"
          path={`${match.url}transaction-list`}
          component={asyncComponent(() => import("./TransactionList/index.js"))}
        />
        <ProtectedRoute
          exact
          permission="commission-summary"
          path={`${match.url}commission-summary`}
          component={asyncComponent(() => import("./Commission/index.js"))}
        />
        {hasAccountReadPermission ? (
          <ProtectedRoute
            exact
            permission="operator-account"
            path={`${match.url}operator-account`}
            component={asyncComponent(
              () => import("./OperatorAccount/index.js"),
            )}
          />
        ) : (
          <ProtectedRoute
            exact
            permission="operator-account"
            path={`${match.url}operator-account`}
            component={asyncComponent(() => import("./NoFound/index.js"))}
          />
        )}
        {hasAccountReadPermission ? (
          <ProtectedRoute
            exact
            permission="operator-bank-account"
            path={`${match.url}operator-bank-account`}
            component={asyncComponent(
              () => import("./OperatorAccount/OperatorBankAcoount/index.js"),
            )}
          />
        ) : (
          <ProtectedRoute
            exact
            permission="operator-bank-account"
            path={`${match.url}operator-bank-account`}
            component={asyncComponent(() => import("./NoFound/index.js"))}
          />
        )}
        <ProtectedRoute
          exact
          permission="deposit-verification-queue"
          path={`${match.url}deposit-verification-queue`}
          component={asyncComponent(() => import("./Deposit/index.js"))}
        />
        <ProtectedRoute
          path={`${match.url}*`}
          exact
          component={asyncComponent(() => import("./NoFound/index.js"))}
        />
      </Switch>
    </div>
  );
};

export default Admin;
